module.exports = __webpack_public_path__ + "static/korea-flag-79791aa1b82ec319446a28648f789d47.svg";